define([
    "jquery",
    "underscore",
    "marionette",
    "signature_pad",
], function($, _, Marionette, SignaturePad){
    return Marionette.Behavior.extend({
        ui: {
            'tcSignature': '#tc_signature',
            'tcSignatureData': '#tc_signature_data',
            'clearTcSignature': '#clear_tc_signature',
            'checkAll': '#check_all',
            'tcCheckbox': '.tc_checkbox',
        },
        common: {
            'signaturePad': null
        },
        events: {

        },

        onPrepareSignatureAndCheckbox: function(){
            this.onPrepareCheckBoxTC();
            this.onPrepareSignatureTC();
        },

        onPrepareCheckBoxTC: function(){
            let that = this;
            let checkAll = $(this.ui.checkAll);
            checkAll.on('click', function(e){
                if(checkAll.is(':checked')) {
                    $(that.ui.tcCheckbox).prop('checked', true);
                } else {
                    $(that.ui.tcCheckbox).prop('checked', false);
                }
            });
        },

        onPrepareSignatureTC: function() {
            let that = this;
            let canvas = document.querySelector("canvas");
            this.common.signaturePad = new SignaturePad(canvas, {
                // defaults to 1
                dotSize: 2,
                // defaults to 0.5
                minWidth: 0.5,
                // defaults to 2.5
                maxWidth: 2.5,
                // defaults to 16
                throttle: 16,
                // defaults to "rgba(0,0,0,0)"
                backgroundColor: "rgba(0,0,0,0)",
                // defaults to "black"
                penColor: "rgb(0, 0, 0)",
                // defaults to 0.7
                velocityFilterWeight: 0.7
            });

            $(this.ui.clearTcSignature).on('click', function(e){
                that.common.signaturePad.clear();
            });

            //without that, the parent of the signature wont have any size
            setTimeout(function (){
                that.onResizeCanvas();
            }, 500);

            $(window).on('resize', function () {
                that.onResizeCanvas();
            });
        },

        onResizeCanvas: function() {
            let canvas = $('#tc_signature').get(0);
            let parent = $('#signature_wrap').get(0);

            canvas.width = parent.offsetWidth;
            canvas.height = parent.offsetHeight;

            this.common.signaturePad.clear();
        },

        onHandleSignatureData: function() {
            if(this.common.signaturePad.isEmpty()){
                $(this.ui.tcSignatureData).val("");
            } else {
                let data = this.common.signaturePad.toDataURL();
                $(this.ui.tcSignatureData).val(data);
            }
        }
    });
});
